import * as React from "react";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { Grid, Fade } from "@mui/material";
import {
  StyledTextField,
  StyledFormButton,
  StyledFormContainer,
} from "../../utils/formStyles";
import osiLogo from "../../utils/images/OSI-LOGO.png";

export function LoginComponent({
  onClickLogin,
}: {
  onClickLogin: (
    type: "user" | "client",
    username: string,
    pass: string,
  ) => void;
}) {
  const [username, setUsername] = useState("");
  const [pass, setPass] = useState("");
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onClickLogin("user", username, pass);
  };

  return (
    <Fade in timeout={800}>
      <StyledFormContainer
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "32px",
          borderRadius: "20px",
          maxWidth: 450,
          margin: "auto",
          boxShadow: "0 8px 32px rgba(90, 100, 119, 0.12)",
          border: "1px solid rgba(255, 255, 255, 0.2)",
        }}
      >
        <Box
          sx={{
            m: 2,
            width: 80,
            height: 80,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 12px rgba(90, 100, 119, 0.3)",
            borderRadius: 2,
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            backdropFilter: "blur(10px)",
          }}
        >
          <img
            src={osiLogo}
            alt="OSI Logo"
            style={{
              width: "70px",
              height: "auto",
              objectFit: "contain",
              filter: "brightness(1.1)",
            }}
          />
        </Box>
        <Typography
          component="h1"
          variant="h4"
          sx={{
            color: "primary.main",
            fontWeight: 600,
            marginBottom: 3,
          }}
        >
          Sign in
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{ mt: 1, width: "100%" }}
        >
          <StyledTextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            value={username}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setUsername(event.target.value)
            }
            sx={{ mb: 2 }}
          />
          <StyledTextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={pass}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setPass(event.target.value)
            }
            sx={{ mb: 3 }}
          />
          <StyledFormButton
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 2, mb: 2, py: 1.5 }}
          >
            Sign In
          </StyledFormButton>
          <Grid container justifyContent="flex-end">
            <Grid item>
              <Link
                href="/login"
                variant="body2"
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  textDecoration: "none",
                  "&:hover": {
                    textDecoration: "underline",
                    color: "secondary.main",
                  },
                }}
              >
                {"Login as Client"}
              </Link>
            </Grid>
          </Grid>
        </Box>
      </StyledFormContainer>
    </Fade>
  );
}
